import { ACCESS_TOKEN_SET, ACCESS_TOKEN_REMOVE } from '@src/redux/actions/accessToken';

export function accessToken(state = null, action) {
  switch (action.type) {
    case ACCESS_TOKEN_SET:
      return action.accessToken;
    case ACCESS_TOKEN_REMOVE:
      return action.accessToken;
    default:
      return state;
  }
}
